import { onConsentReady } from 'frontend/shared/javascripts/util/gdpr_consent'

up.compiler('[data-sticky]', (element) => {
  // Closing the GDPR consent overlay results in crashing Chrome when the page contains a sticky list. Therefore we
  // make the list sticky when the GDPR consent overlay is closed or a vendor consent is given.
  onConsentReady(() => {
    element.classList.add('-sticky')
  })
})
